import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/down_active_icon1.png'
import _imports_1 from '@/assets/img/new/down_icon1.png'
import _imports_2 from '@/assets/img/tx.jpg'
import _imports_3 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-4964f0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "record_page" }
const _hoisted_2 = { class: "video_box" }
const _hoisted_3 = { class: "like" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "video_tag"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video_txt" }, "您暂无权限访问当前视频~", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "record_des"
}
const _hoisted_10 = { class: "nav_txt1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "nav_txt" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附加文件", -1))
const _hoisted_15 = {
  key: 0,
  class: "nav_file"
}
const _hoisted_16 = { class: "file_left" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "file_size" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_21 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_22 = { class: "comm_box" }
const _hoisted_23 = { class: "comm_input" }
const _hoisted_24 = {
  key: 0,
  class: "comm_scorll"
}
const _hoisted_25 = { class: "comm_list" }
const _hoisted_26 = { class: "comm_item_ava" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_29 = { class: "chat_right" }
const _hoisted_30 = { class: "comm_item_name" }
const _hoisted_31 = { class: "comm_item_chat" }
const _hoisted_32 = { class: "comm_item_time" }
const _hoisted_33 = {
  key: 1,
  class: "null_box"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "record_right" }
const _hoisted_38 = {
  key: 0,
  class: "right_bg"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record_title" }, " 主讲老师介绍 ", -1))
const _hoisted_40 = {
  key: 0,
  class: "user_info"
}
const _hoisted_41 = { class: "user_info_box" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user_info_ava" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_43 = { class: "user_info_txt" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = {
  key: 1,
  class: "right_bg"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record_title" }, " 相关课程 ", -1))
const _hoisted_47 = { class: "course_list" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "course_right" }
const _hoisted_52 = { class: "course_item_txt" }
const _hoisted_53 = {
  key: 1,
  class: "null_box"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]

import { reactive, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { TResponse } from "@/module/common"
import { TRecordDetailsType, TRecordVideoType } from '@/module/record';
import { getRecordDetails, getRecordVideoList } from "@/api/record";
import { GetAddCollect, GetRemoveCollect } from '@/hooks/collectInter' // 混入收藏接口
import { GetAddComment, GetCommentList } from '@/hooks/commentInter' // 混入评论接口
import { GetAddFabulous, GetRemoveFabulous } from '@/hooks/fabulousInter' // 混入点赞接口
import { ElLoading, ElMessage } from 'element-plus'
import { GetaddLearnTake } from '@/hooks/public' // 混入学习记录接口
import Video from "@/components/Video/video.vue";
import getFileTypeImg from '@/hooks/use_type_imgs'
import { fileHandle } from '@/hooks/file_preview_download'
import {useStore} from "vuex"

export default /*#__PURE__*/_defineComponent({
  __name: 'recordDetails',
  setup(__props) {

const { onPreview, addExtension, downLoad, previewPic } = fileHandle()
let person: any = reactive({
    sourceMaterialList: [],//右侧素材数组
    materialInfo: {},//录播详情
    teacherInfo: {},
    courseList:[],
    tools: [
        { img: require('@/assets/img/new/thumbs_icon.png'), activeImg: require('@/assets/img/new/thumbs_active_icon.png'), numTotal: 0, isFinish: false },
        { img: require('@/assets/img/new/collect_icon.png'), activeImg: require('@/assets/img/new/collect_active_icon.png'), numTotal: 0, isFinish: false },
        { img: require('@/assets/img/new/comm_active_icon.png'), activeImg: require('@/assets/img/new/comm_active_icon.png'), numTotal: 0, isFinish: false }
    ],
    isShowComm: false, // 是否显示评论
    inputValue: '', // 评论输入框
    commentList: [],
    activeName: '0',
    currTime: 0,
    duration: 0,
    totalTime: 0,
    Progress: '',
    RecordSectionId: 0,
    RecordChapterId: 0,
    IsCollect: 0,
    totalTimeFun: null,
    AddLearnFun: null,
    setIntervalTime: 0,
    times: '',
    isShowNext: false, // 是否显示下一节
    nextIndex: 0,
    isVideo: false,
    dataDetails: null,
    ResourcesList:[],
    activeNames:[],
    obj:{},
    isShow:0,
    token:'',
    openClass:{},
    isOpenClass:false,
    imgs: [require('@/assets/img/new/course_1.png'), require('@/assets/img/new/course_2.png'), require('@/assets/img/new/course_3.png')]
})
const router = useRouter();
const route = useRoute();
const store = useStore()
const url = ref()

const backPage=()=>{
    router.back()
}
person.token = localStorage.getItem('token')
// 获取缓存的是否公开课
person.openClass = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("openClass"))))
if (person.openClass) {
    // person.isOpenClass 是否下载
    person.isOpenClass = person.openClass.isOpenClass
}

// 添加学习记录
let load = () => {
    let body = {
        RecordSectionId: person.RecordSectionId,
        RecordType: 1,
        RecordChapterId: person.RecordChapterId,
        RecordNum: 0,
        Progress: person.Progress,
        ProgressTime: person.totalTime,
        ProgressTimes: person.currTime
    }
    // 判断是否登录
    if (person.token){
        if (person.currTime > 0 && person.Progress<100){
            GetaddLearnTake(body)
            person.totalTime=0
        }else{
            GetaddLearnTake(body)
            person.totalTime = 0
        }
    }
}

// 随机3-5秒 调用一次学习记录接口
let CallbackTime=(currTime:number,duration:number)=>{
    person.currTime = Math.ceil(currTime)
    person.duration = Math.ceil(duration)
    person.Progress = (person.currTime / person.duration *100)
    if (person.currTime === person.duration && person.IsLastAdd===0) {
        person.IsLastAdd=1
        console.log('是否看完', person.currTime === person.duration);
        person.totalTime =0
        load()
        CallbackPause()
    }
}
let items = [3000, 4000, 5000];
let CallbackPaly = ()=>{
    person.totalTimeFun = setInterval(() => {
        person.totalTime += 1
    }, 1000)
    let item = items[Math.floor(Math.random() * items.length)];
    person.AddLearnFun = setInterval(() => {
        load()
    }, item)
}
let CallbackPause=()=>{
    clearInterval(person.totalTimeFun)
    clearInterval(person.AddLearnFun)
}
onUnmounted(()=>{
    CallbackPause()
    console.log(99999,store.state.isClose);
})

// 目录切换
let menuClick = (tab: any, event: Event) => {
    // 评论
    if (tab.index === '1') {
        GetCommentList(person, person.materialInfo.Id, 1, 1, 120)
    }
}
// 工具切换
let ToolClick = (tool: any, toIndex: number) => {
    tool.isFinish = !tool.isFinish
    if (toIndex === 0) {
        if (tool.isFinish) {
            // 添加点赞
            GetAddFabulous(tool, tool.Id, 1)
        } else {
            // 取消点赞
            GetRemoveFabulous(tool, tool.Id, 1)
        }
    }
    if (toIndex === 1) {
        if (tool.isFinish) {
            // 添加收藏 1录播 2直播
            GetAddCollect(tool, tool.Id, 1)
        } else {
            // 取消收藏
            GetRemoveCollect(tool, tool.Id, 1)
        }
    }
    if (toIndex === 2) {
        person.activeName = '1'
        document.getElementsByClassName('record_page')[0].scrollTop = 600
        if (tool.isFinish) {
            //  评论列表 List, ObjId, Type, PageIndex, PageSize
            GetCommentList(person, tool.Id, 1, 1, 120)
        }
    }
}
// 当前日期时间
const time = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    person.times = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
};
// 评论
let commBtn = (item: any) => {
    if (!person.inputValue) {
        ElMessage('内容不能为空！')
    } else {
        if (person.token) {
            // 添加评论 Id, Type, Content, ParentId
            GetAddComment(item.Id, 1, person.inputValue, 0)
            // 添加评论 Id, Type, Content, ParentId
            let userinfo = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo"))));
            time()
            let obj = { Content: person.inputValue, CreateTime: person.times, UserHead: "", UserName: userinfo.Name }
            person.inputValue = ''
            person.commentList.unshift(obj)
            person.tools[2].numTotal = person.commentList.length + 1
        } else {
            ElMessage('请登录后再试！')
        }
    }
}

const getCache=()=>{
    // 获取缓存的id
    person.obj = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("setId"))))
    if (person.obj) {
        person.RecordSectionId = person.obj.Id
        person.RecordChapterId = person.obj.NodeId
        person.IsCollect = person.obj.IsCollect
    }
}

// 获取录播详情 type 切换传除0之外的任意值
// type 为1 具体某一节，为0 是课程
const getInfo = async (type: number,isFirst= 1) => {
    getCache()
    CallbackPause()
    if (person.RecordChapterId !== person.RecordSectionId){
        type=1
    }
    let res: TResponse<TRecordDetailsType> = await getRecordDetails({ Id: person.RecordSectionId, type: type })
    let { Code, Data } = res
    if (Code === 200 && Data) {
        person.dataDetails = Data
        let { Id, Name, VideoName, VideoId, ProgressTimes, IsAuthPayer, MaxProgress, PlayAddress, IsCollection, ResourcesList, CollectionNum, LearningNum, IsFabulous, FabulousNum, CommentNum, Desc, TeacherInfo, curriculumLists } = Data
        person.materialInfo = { // 基本信息
            Id: Id,
            Name: Name,
            VideoName: VideoName,
            VideoId: VideoId,
            PlayAddress: PlayAddress,
            IsCollection: IsCollection,
            CollectionNum: CollectionNum,
            LearningNum: LearningNum,
            IsFabulous: IsFabulous,
            FabulousNum: FabulousNum,
            CommentNum: CommentNum,
            Desc: Desc,
            ProgressTimes: ProgressTimes,
            MaxProgress: MaxProgress,
            IsAuthPayer: IsAuthPayer
        }
        person.ResourcesList = ResourcesList
        person.isVideo = true
        url.value = PlayAddress
        console.log('地址', person.materialInfo.PlayAddress);
        person.teacherInfo = TeacherInfo // 老师信息
        person.courseList= curriculumLists // 课程列表
        person.tools.forEach((item: any, itIndex: number) => {
            item.Id = person.materialInfo.Id
            if (itIndex === 0) {
                item.numTotal = person.materialInfo.FabulousNum
                item.isFinish = person.materialInfo.IsFabulous
            } else if (itIndex === 1) {
                item.numTotal = person.materialInfo.CollectionNum
                item.isFinish = person.materialInfo.IsCollection
            } else if (itIndex === 2) {
                item.numTotal = person.materialInfo.CommentNum
            }
        })
        if (isFirst==1)
            await GetRecordVideoList()
    }
}

if (person.obj) {
    if (person.IsCollect > 0) {
        getInfo(1)
    } else {
        getInfo(0)
    }
}
// 获取录播视频列表
const GetRecordVideoList = async () => {
    let res: TResponse<TRecordVideoType[]> = await getRecordVideoList({ NodeId: person.RecordChapterId })
    let { Code, Data } = res
    if (Code === 200 && Data && Data.length > 0) {
        person.sourceMaterialList = Data
        // 设置所有折叠面展开
        for (var i = 0; i < Data.length; i++) {
            person.activeNames.push(i + 1 + '')
        }
        person.RecordSectionId = person.materialInfo.Id
    }
}

// 打开附加文件
const openFile = (item: any, index: number) => {
    person.fileId = item.Id
}
//下载
const dowmClick = (item: any, index: number) => {
    if (item.DownState && person.isOpenClass) {
        downLoad(item)
    }
}

//查看图片
const previewPicClick = (row: any, index: number) => {
    if (row.DownState && row.Type === 4) {
        person.data.list[index].isPic = !person.data.list[index].isPic
    }
}
// 目录一级切换
let handleChange = (item: any) => {
    console.log(333,item);
}
// 目录二级切换
let changeNav = (item: any, index: number) => {
    person.RecordSectionId = item.Id
    person.RecordChapterId = person.obj.NodeId
    let obj = { Id: person.RecordSectionId, NodeId: person.RecordChapterId, IsCollect:1 }
    localStorage.setItem('setId', JSON.stringify(obj))
    getInfo(1,0)
    person.isVideo = false
    person.activeName = '0'
    document.getElementsByClassName('record_page')[0].scrollTop = 0
    person.nextIndex = index
}

// 跳转
let toDetails = (teacherInfo: any, item: any) => {
    if (item.CurriculumType === 1 && item.State === 1) { // 直播未开始
        ElMessage('直播还未开始')
    } else if (item.CurriculumType === 1 && item.State === 2) { // 直播中
        router.push({ name: 'liveDetails', query: { Id: item.Id, teacherInfo: JSON.stringify(teacherInfo) } })
    } else if (item.CurriculumType === 0) { // 录播
        playBack(item)
    }
}
// 查看回放
let playBack=(item:any)=>{
    person.RecordSectionId = item.Id
    person.RecordChapterId = item.ChapterId
    let obj = { Id: item.Id, NodeId: item.ChapterId, IsCollect: -1 }
    localStorage.setItem('setId', JSON.stringify(obj))
    getInfo(0,1)
    person.activeName='0'
    document.getElementsByClassName('record_page')[0].scrollTop = 0
}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "video_title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (backPage()))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        }),
        _createTextVNode(_toDisplayString(_unref(person).materialInfo.Name?_unref(person).materialInfo.Name:'暂无课程'), 1)
      ]),
      (_unref(person).isVideo)
        ? (_openBlock(), _createBlock(Video, {
            key: 0,
            Url: url.value,
            onCallbackTime: _unref(CallbackTime),
            onCallbackPause: _unref(CallbackPause),
            onCallbackPaly: _unref(CallbackPaly),
            datainfo: _unref(person).materialInfo,
            currTime: _unref(person).materialInfo.ProgressTimes,
            isShowNext: _unref(person).isShowNext
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).tools, (tool, toIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: toIndex,
                    onClick: ($event: any) => (_unref(ToolClick)(tool,toIndex))
                  }, [
                    _createElementVNode("img", {
                      src: tool.isFinish?tool.activeImg:tool.img,
                      alt: ""
                    }, null, 8, _hoisted_5),
                    _createElementVNode("span", null, _toDisplayString(tool.numTotal), 1)
                  ], 8, _hoisted_4))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["Url", "onCallbackTime", "onCallbackPause", "onCallbackPaly", "datainfo", "currTime", "isShowNext"]))
        : _createCommentVNode("", true),
      (!_unref(person).materialInfo.IsAuthPayer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    (_unref(person).dataDetails!=null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_el_tabs, {
            modelValue: _unref(person).activeName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(person).activeName) = $event)),
            class: "record_tabs",
            onTabClick: _unref(menuClick)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "目录",
                name: "0",
                class: "nav_list"
              }, {
                default: _withCtx(() => [
                  (_unref(person).sourceMaterialList && _unref(person).sourceMaterialList.length>0)
                    ? (_openBlock(), _createBlock(_component_el_collapse, {
                        key: 0,
                        modelValue: _unref(person).activeNames,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(person).activeNames) = $event)),
                        onChange: _unref(handleChange)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).sourceMaterialList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock(_component_el_collapse_item, {
                              class: "nav_item1",
                              key: itemIndex,
                              title: "标题",
                              name: itemIndex+1+''
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(item.Name), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.CList, (chi, chiIndex) => {
                                  return (_openBlock(), _createElementBlock("div", { key: chiIndex }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["nav_text", [_unref(person).RecordSectionId === chi.Id?'nav_text_active':'']]),
                                      onClick: ($event: any) => (_unref(changeNav)(chi,chiIndex))
                                    }, [
                                      _createElementVNode("div", _hoisted_12, _toDisplayString(chi.Name), 1),
                                      (chi.ResourcesList&&chi.ResourcesList.length>0)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "nav_btn",
                                            onClick: _withModifiers(($event: any) => (openFile(chi,chiIndex)), ["stop"])
                                          }, [
                                            _hoisted_14,
                                            _createElementVNode("i", {
                                              class: _normalizeClass(chi.Id===_unref(person).fileId?'el-icon-arrow-up':'el-icon-arrow-down')
                                            }, null, 2)
                                          ], 8, _hoisted_13))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_11),
                                    (chi.Id===_unref(person).fileId)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chi.ResourcesList, (resou, reIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "file_item",
                                              key: reIndex
                                            }, [
                                              _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("img", {
                                                  src: _unref(getFileTypeImg)(resou.Extension),
                                                  alt: ""
                                                }, null, 8, _hoisted_17),
                                                _createElementVNode("span", null, _toDisplayString(resou.Name) + _toDisplayString('.'+resou.Extension), 1),
                                                _createElementVNode("span", _hoisted_18, _toDisplayString((resou.Size/1024).toFixed(2)) + "M", 1)
                                              ]),
                                              _createElementVNode("div", {
                                                class: "file_right",
                                                onClick: ($event: any) => (dowmClick(resou,reIndex))
                                              }, [
                                                _createTextVNode(" 下载 "),
                                                (resou.DownState&&_unref(person).isOpenClass)
                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                                                  : (_openBlock(), _createElementBlock("img", _hoisted_21))
                                              ], 8, _hoisted_19)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["name"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "评论",
                name: "1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(person).inputValue,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(person).inputValue) = $event)),
                        placeholder: "发布你的评论",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(commBtn)(_unref(person).materialInfo)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("评论")
                        ]),
                        _: 1
                      })
                    ]),
                    (_unref(person).commentList&&_unref(person).commentList.length>0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).commentList, (comm, commIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "comm_item",
                                key: commIndex
                              }, [
                                _createElementVNode("div", _hoisted_26, [
                                  (comm.UserHead)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: comm.UserHead,
                                        alt: ""
                                      }, null, 8, _hoisted_27))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_28))
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(comm.UserName), 1),
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(comm.Content), 1),
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(comm.CreateTime), 1)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_36))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"]),
          _createElementVNode("div", _hoisted_37, [
            (_unref(person).teacherInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _hoisted_39,
                  (_unref(person).teacherInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", null, _toDisplayString(_unref(person).teacherInfo.Name), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(person).teacherInfo.SchoolName), 1)
                          ])
                        ]),
                        (_unref(person).teacherInfo.Desc!==null)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "user_info_des",
                              innerHTML: _unref(person).teacherInfo.Desc
                            }, null, 8, _hoisted_44))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(person).courseList&&_unref(person).courseList.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).courseList, (course, couIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "course_item",
                        key: couIndex,
                        onClick: ($event: any) => (_unref(toDetails)(_unref(person).teacherInfo,course))
                      }, [
                        (course.CoverUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: course.CoverUrl,
                              alt: ""
                            }, null, 8, _hoisted_49))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _unref(person).imgs[Math.floor(Math.random() * (_unref(person).imgs.length))],
                              alt: ""
                            }, null, 8, _hoisted_50)),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, _toDisplayString(couIndex + 1) + "." + _toDisplayString(course.Name), 1)
                        ])
                      ], 8, _hoisted_48))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_56))
  ]))
}
}

})